import { useTranslation } from 'next-i18next/pages';
import Image, { StaticImageData } from 'next/image';

import { ReactComponent as CheckCircle } from '@pflegia/ui/icons/check-circle.svg';
import { getButtonClassName } from '@pflegia/ui/shared/button';
import ButtonLink from '@pflegia/ui/shared/button-link/ButtonLink';

import { FUNNEL } from '@shared/application/constants';
import { RegisterButtonTrackingIds } from '@shared/application/marketing/events/register-button';
import { useTracking } from '@shared/application/tracking.service';

interface EmploymentTypeCardProps {
  image: StaticImageData;
  name: string;
  alt?: string;
}

const EmploymentTypeCard: React.FC<EmploymentTypeCardProps> = ({ image, name, alt }) => {
  const { t } = useTranslation('landingPage', { keyPrefix: `selectEmploymentType.${name}` });
  const list = t('list', { returnObjects: true });
  const { signupButtonClickTrackEventRegistration } = useTracking();
  return (
    <div className='flex flex-col overflow-hidden rounded-2xl shadow-2xl'>
      <Image alt={alt ?? ''} className='object-cover' height={155} src={image} width={373} />
      <div className='flex grow flex-col p-4'>
        <h3 className='mb-6 mt-2 font-handwriting text-3xl text-main-blue'>{t('title')}</h3>
        <ul className='mb-8 flex flex-col gap-2'>
          {Array.isArray(list) &&
            list.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li className='flex items-start gap-2 text-lg text-default' key={`${index}-${item}`}>
                <CheckCircle className='mt-1 shrink-0 text-main-blue' height={18} width={18} />
                {item}
              </li>
            ))}
        </ul>
        <ButtonLink
          href={FUNNEL}
          className={getButtonClassName('primary', 'mt-auto self-center')}
          onClick={() =>
            signupButtonClickTrackEventRegistration(
              name === 'permanent'
                ? RegisterButtonTrackingIds.LandingPagePermanentCardId
                : RegisterButtonTrackingIds.LandingPageFlexibleCardId,
            )
          }>
          {t('cta')}
        </ButtonLink>
      </div>
    </div>
  );
};

export default EmploymentTypeCard;
